module.exports = __webpack_public_path__ + "static/media/USDT-AVAX.cea00ebe.svg";